// import React, { useState } from 'react';

// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
// import { Form as FinalForm } from 'react-final-form';

// import EmailTemplateForm from 'components/EmailTemplateForm/EmailTemplateForm';

// import {
//     actions,
// } from 'coupon-common/src/modules/admin/emailManager';

// const EditEmailTemplate = ({
//     dispatch,
//     templates,
//     selectedTemplate,
//     initialValues,
//     onTemplateChange,
//     onPreview,
//     onUpdated,
//     styles,
// }) => {
//     const [submitting, setSubmitting] =
//         useState(false);

//     const handleUpdate = values => {
//         if (!selectedTemplate) {
//             return;
//         }

//         const payload = {
//             name: values.name,
//             subject: values.subject,
//             body: values.body,
//             enabled: values.enabled,
//             transactional: values.transactional,
//         };

//         setSubmitting(true);

//         dispatch(
//             actions.updateEmailTemplate(
//                 selectedTemplate.id,
//                 payload,
//                 result => {
//                     setSubmitting(false);
//                     if (result?.success) {
//                         onUpdated();
//                     } else {
//                         alert("There was an error updating the template")
//                         // console.error(
//                         //     'Failed to update email template:',
//                         //     result?.error
//                         // );
//                     }
//                 }
//             )
//         );
//     };

//     if (!templates.length) {
//         return (
//             <div className={styles.editor}>
//                 <h4>Edit Email Template</h4>

//                 <div>
//                     No email templates available.
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className={styles.editor}>
//             <h4>Edit Email Template</h4>

//             <div className="mb-3">
//                 <label
//                     htmlFor="template-select"
//                     className="form-label"
//                 >
//                     Template
//                 </label>

//                 <select
//                     id="template-select"
//                     className="form-select"
//                     value={selectedTemplate?.id || ''}
//                     onChange={onTemplateChange}
//                     disabled={submitting}
//                 >
//                     {templates.map(template => (
//                         <option
//                             key={template.id}
//                             value={template.id}
//                         >
//                             {template.name}
//                         </option>
//                     ))}
//                 </select>
//             </div>

//             {selectedTemplate && (
//                 <FinalForm
//                     key={selectedTemplate.id}
//                     initialValues={initialValues}
//                     onSubmit={handleUpdate}
//                     render={({
//                         handleSubmit,
//                         values,
//                     }) => (
//                         <form onSubmit={handleSubmit}>
//                             <EmailTemplateForm
//                                 values={values}
//                                 onPreview={onPreview}
//                                 isEdit
//                                 isBaseTemplate={
//                                     selectedTemplate.name ===
//                                     'BASE_EMAIL_TEMPLATE'
//                                 }
//                                 submitLabel="Save Changes"
//                                 submitting={submitting}
//                             />
//                         </form>
//                     )}
//                 />
//             )}
//         </div>
//     );
// };

// EditEmailTemplate.propTypes = {
//     dispatch: PropTypes.func.isRequired,
//     templates: PropTypes.array.isRequired,
//     selectedTemplate: PropTypes.object,
//     initialValues: PropTypes.object.isRequired,
//     onTemplateChange: PropTypes.func.isRequired,
//     onPreview: PropTypes.func.isRequired,
//     onUpdated: PropTypes.func.isRequired,
//     styles: PropTypes.object.isRequired,
// };

// EditEmailTemplate.defaultProps = {
//     selectedTemplate: null,
// };

// export default connect()(EditEmailTemplate);

import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';

import EmailTemplateForm from 'components/EmailTemplateForm/EmailTemplateForm';

import {
    actions,
} from 'coupon-common/src/modules/admin/emailManager';

const EditEmailTemplate = ({
    dispatch,
    templates,
    selectedTemplate,
    initialValues,
    onTemplateChange,
    onPreview,
    onSendTestEmail,
    onUpdated,
    styles,
}) => {
    const [submitting, setSubmitting] =
        useState(false);

    const handleUpdate = values => {
        if (!selectedTemplate) {
            return;
        }

        const payload = {
            name: values.name,
            subject: values.subject,
            body: values.body,
            enabled: values.enabled,
            transactional: values.transactional,
        };

        setSubmitting(true);

        dispatch(
            actions.updateEmailTemplate(
                selectedTemplate.id,
                payload,
                result => {
                    setSubmitting(false);

                    if (result?.success) {
                        onUpdated();
                        alert( 'Template updated successfully');
                    } else {
                        alert("There was an error updating the template.")
                        // console.error(
                        //     'Failed to update email template:',
                        //     result?.error
                        // );
                    }
                }
            )
        );
    };

    if (!templates.length) {
        return (
            <div className={styles.editor}>
                <h4>Edit Email Template</h4>

                <div>
                    No email templates available.
                </div>
            </div>
        );
    }

    return (
        <div className={styles.editor}>
            <h4>Edit Email Template</h4>

            <div className="mb-3">
                <label
                    htmlFor="template-select"
                    className="form-label"
                >
                    Template
                </label>

                <select
                    id="template-select"
                    className="form-select"
                    value={
                        selectedTemplate?.id || ''
                    }
                    onChange={onTemplateChange}
                    disabled={submitting}
                >
                    {templates.map(template => (
                        <option
                            key={template.id}
                            value={template.id}
                        >
                            {template.name}
                        </option>
                    ))}
                </select>
            </div>

            {selectedTemplate && (
                <FinalForm
                    key={selectedTemplate.id}
                    initialValues={initialValues}
                    onSubmit={handleUpdate}
                    render={({
                        handleSubmit,
                        values,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <EmailTemplateForm
                                values={values}
                                onPreview={onPreview}
                                onSendTestEmail={
                                    onSendTestEmail
                                }
                                isEdit
                                isBaseTemplate={
                                    selectedTemplate.name ===
                                    'BASE_EMAIL_TEMPLATE'
                                }
                                submitLabel="Save Changes"
                                submitting={submitting}
                            />
                        </form>
                    )}
                />
            )}
        </div>
    );
};

EditEmailTemplate.propTypes = {
    dispatch: PropTypes.func.isRequired,
    templates: PropTypes.array.isRequired,
    selectedTemplate: PropTypes.object,
    initialValues: PropTypes.object.isRequired,
    onTemplateChange: PropTypes.func.isRequired,
    onPreview: PropTypes.func.isRequired,
    onSendTestEmail: PropTypes.func.isRequired,
    onUpdated: PropTypes.func.isRequired,
    styles: PropTypes.object.isRequired,
};

EditEmailTemplate.defaultProps = {
    selectedTemplate: null,
};

export default connect()(EditEmailTemplate);